import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × ROLLS-ROYCE: Engineered grace
// Silver wings, geometric flow, motion symmetry
export function VasarelyRollsroyceMode({ brand }: ModeRendererProps) {
  const rrSilver = "#C0C0C0";
  const rrBlack = "#000000";

  return (
    <g>
      {/* Elegant dark background */}
      <defs>
        <linearGradient id="rolls-elegance" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#1A1A1A" />
          <stop offset="50%" stopColor="#0A0A0A" />
          <stop offset="100%" stopColor="#1A1A1A" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#rolls-elegance)" />

      <g transform="translate(397 540)">
        {/* Spirit of Ecstasy wings */}
        {[-1, 1].map((dir) => {
          const points = Array.from({ length: 30 }).map((_, i) => {
            const t = i / 29;
            const x = dir * t * 200;
            const y = -100 + t * 200;
            const curve = Math.sin(t * Math.PI) * 60;
            return `${x + curve},${y}`;
          }).join(" ");
          
          return (
            <polyline
              key={dir}
              points={points}
              fill="none"
              stroke={rrSilver}
              strokeWidth="3"
              opacity="0.6"
            />
          );
        })}

        {/* Geometric flow lines */}
        {Array.from({ length: 18 }).map((_, i) => {
          const y = -260 + i * 29;
          const points = Array.from({ length: 40 }).map((_, j) => {
            const x = -280 + j * 14;
            const flow = Math.sin(j * 0.15) * 15;
            return `${x},${y + flow}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={rrSilver}
              strokeWidth="1"
              opacity="0.25"
            />
          );
        })}

        {/* Motion symmetry grid */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = (i - 6.5) * 44;
            const y = (j - 8.5) * 42;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 18}
                y={y - 18}
                width="36"
                height="36"
                fill="none"
                stroke={rrSilver}
                strokeWidth="0.5"
                opacity="0.15"
              />
            );
          })
        )}

        {/* Pantheon grille inspiration (vertical bars) */}
        {Array.from({ length: 9 }).map((_, i) => {
          const x = -80 + i * 20;
          return (
            <rect
              key={i}
              x={x - 4}
              y="-120"
              width="8"
              height="240"
              fill={rrSilver}
              opacity="0.4"
            />
          );
        })}

        {/* Precision circles */}
        {Array.from({ length: 16 }).map((_, i) => {
          const r = 40 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={rrSilver}
              strokeWidth="1"
              opacity={0.3 - i * 0.016}
            />
          );
        })}

        {/* Performance nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="16"
                fill={rrSilver}
                opacity="0.5"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="16"
                fill="none"
                stroke={brand.white}
                strokeWidth="2"
                opacity="0.7"
              />
            </g>
          );
        })}

        {/* Central RR monogram inspiration */}
        <rect x="-60" y="-80" width="120" height="160" fill="none" stroke={rrSilver} strokeWidth="4" opacity="0.7" rx="10" />
        
        {/* Double R abstraction */}
        <ellipse cx="-25" cy="0" rx="20" ry="35" fill="none" stroke={brand.white} strokeWidth="3" opacity="0.8" />
        <ellipse cx="25" cy="0" rx="20" ry="35" fill="none" stroke={brand.white} strokeWidth="3" opacity="0.8" />
        <line x1="-25" y1="0" x2="-5" y2="35" stroke={brand.white} strokeWidth="3" opacity="0.8" />
        <line x1="25" y1="0" x2="45" y2="35" stroke={brand.white} strokeWidth="3" opacity="0.8" />
      </g>

      {/* Rolls-Royce text */}
      <text x="397" y="1025" textAnchor="middle" fontFamily="serif" fontSize="11" fill={rrSilver} opacity="0.8" fontStyle="italic">
        grâce ingénierie
      </text>
    </g>
  );
}
